import React, { Component } from "react";
import plus from "../../Images/plus.png";
import Grid from "@material-ui/core/Grid";
import "./DashboardMaster.css";
import Modalcomp from "../../helpers/ModalComp/Modalcomp";
import DashboardTable from "./DashboardTable";
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";

import dateFormat from "dateformat";
import Labelbox from "../../helpers/labelbox/labelbox";
import Paper from "@material-ui/core/Paper";
import DateRangeSelect from "../../helpers/DateRange/DateRange";
import { withTranslation } from 'react-i18next';
const current_date = dateFormat(new Date(), "dd-mmm-yy");

class DashboardMaster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  render() {
    const { t } = this.props;
    return (
      <div>
          <DashboardTable ref="pharmacyDashboardPageRef" t={t} i18n={this.props.i18n}/>
      </div>
    );
  }
}
export default withTranslation()(DashboardMaster);
